export const selectVendors = (state) => state.vendor.vendors;
export const selectVendorsLoading = (state) => state.vendor.loading;
export const selectVendorsError = (state) => state.vendor.error;
export const selectApprovedVendors = (state) => 
  state.vendor.vendors.filter(vendor => vendor.isApproved);
export const selectPendingVendors = (state) => 
  state.vendor.vendors.filter(vendor => !vendor.isApproved);